import { render, staticRenderFns } from "./medicineMessageRecord.vue?vue&type=template&id=337065aa&scoped=true&"
import script from "./medicineMessageRecord.vue?vue&type=script&lang=js&"
export * from "./medicineMessageRecord.vue?vue&type=script&lang=js&"
import style0 from "./medicineMessageRecord.vue?vue&type=style&index=0&id=337065aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337065aa",
  null
  
)

export default component.exports